import { render, staticRenderFns } from "./AssistanceSidebarSend.vue?vue&type=template&id=c7307a64&"
import script from "./AssistanceSidebarSend.vue?vue&type=script&lang=js&"
export * from "./AssistanceSidebarSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports